import { API_ROUTES } from "../../configuration/RoutesApi"
import { PutRequest } from "../../services/ApiClientService"
import { companyMemory } from "../../Objects/Memory/Memory"
import type { CompanyModuleStatusEntry } from "../../Objects/Company/CompanyModulesStatus"

export const useUpdateCompanyModules = () => {
  const handleUpdateModules = async (disabledModuleCodes: string[]) =>
    PutRequest<CompanyModuleStatusEntry[], { disabledModuleCodes: string[] }>(
      API_ROUTES.COMPANY.UPDATE_MODULES(companyMemory.id),
      { disabledModuleCodes },
    )

  return { handleUpdateModules }
}
